import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Autocomplete,
  Link as MuiLink,
  Skeleton,
  InputAdornment,
  TablePagination,
  Grid2,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Iconify } from "src/components/iconify";
import Header from '../Header';
import Footer from '../Footer';
import { API_URL, BASE_URL } from '../Config';
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../common/Config";
import '../common/commonStyles.css';
import { toast } from 'sonner';
import { postCreatePickingList, postCreatePicking, fetchGetPicker } from "../../utils/pickingApi";
const PickingCreate = (props) => {
  const location = useLocation();
  const inTabs = location.pathname === '/picking/picking_list';
  const [options, setOptions] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [picker, setSelectedPicker] = useState('');
  const [newOrders, setNewOrders] = useState([]);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerInputValue, setCustomerInputValue] = useState('');
  const [isSingleOrderPicking, setIsSingleOrderPicking] = useState(false);
  const [singlePickingSuccessCount, setSinglePickingSuccessCount] = useState(0);
  const navigateToOrderHistory = useNavigate();
  const accessToken = localStorage.getItem('accessToken');
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const pickerRef = useRef(null);

  const columns = [
    { id: "checkbox", label: "#", width: 60 },
    { id: "date", label: "Order Date", width: 120 },
    { id: "reference_no", label: "Order Id", width: 120 },
    { id: "customer", label: "Customers (Ac/No)", width: 200 },
    { id: "postal_code", label: "Post Code", width: 150 },
    { id: "route_number", label: "Route No", width: 150 },
    { id: "grand_total", label: "Order Amt", width: 150, numeric: true },
    { id: "total", label: "Total", width: 100 },
    { id: "first_name", label: "Order By", width: 150 },
    { id: "deliverydate", label: "Delivery Date", width: 150 },
  ];

  async function fetchData() {
    const accessToken = localStorage.getItem('accessToken');
    const token = localStorage.getItem("token");

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    setLoading(true);

    try {
      const data = await postCreatePickingList({
        searchByFromdate: fromDate,
        searchByTodate: toDate,
        draw: String(draw),
        start: String(start),
        length: String(length),
        pickerId: picker,
        authorization: `Bearer ${token}`,
      }, token);

      setNewOrders(Array.isArray(data.data) ? data.data : []);
      if (data.isSingleOrderPicking === 'Y') {
        setIsSingleOrderPicking(true);
      }

    } catch {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchPickerOptions() {
      try {
        if (accessToken === null) {
          window.location.href = `${config.BASE_URL}/login`;
          return;
        }

        const payload = await fetchGetPicker(token);

        if (!payload || !payload.picker || !Array.isArray(payload.picker)) {
          throw new Error('Invalid response format or empty picker array');
        }

        const formattedOptions = payload.picker.map(item => ({
          label: `${item.first_name} ${item.last_name}`,
          value: item.id,
        }));
        setCustomerOptions(formattedOptions);

      } catch {
      }
    }

    fetchPickerOptions();
  }, []);

  const handleChange = (event, newValue) => {
    setCustomerInputValue(newValue);
    if (newValue) {
      setSelectedPicker(newValue.value);
    } else {
      setSelectedPicker('');
    }
  };

  const handlePickerChange = (event, newInputValue) => {
    // This is for input change tracking if needed
  };

  const handleCheckboxChange = (orderId) => {
    //if (isSingleOrderPicking) {
      // For single order picking, uncheck all others
      // const newCheckedItems = {};
      // if (!checkedItems[orderId]) {
      //   newCheckedItems[orderId] = true;
      // }
      // setCheckedItems(newCheckedItems);
    ///} else {
      // For multiple order picking, toggle the specific checkbox
      const newCheckedItems = { ...checkedItems };
      if (checkedItems[orderId]) {
        delete newCheckedItems[orderId];
      } else {
        newCheckedItems[orderId] = true;
      }
      setCheckedItems(newCheckedItems);
   // }
  };

  // Filter orders based on search term
  const filteredOrders = useMemo(() => {
    if (!searchTerm.trim()) {
      return newOrders;
    }
    const searchLower = searchTerm.toLowerCase().trim();
    return newOrders.filter((order) => {
      return (
        (order.reference_no && order.reference_no.toLowerCase().includes(searchLower)) ||
        (order.customer && order.customer.toLowerCase().includes(searchLower)) ||
        (order.postal_code && order.postal_code.toLowerCase().includes(searchLower)) ||
        (order.route_number && String(order.route_number).toLowerCase().includes(searchLower)) ||
        (order.date && order.date.toLowerCase().includes(searchLower)) ||
        (order.first_name && order.first_name.toLowerCase().includes(searchLower)) ||
        (order.deliverydate && order.deliverydate.toLowerCase().includes(searchLower))
      );
    });
  }, [newOrders, searchTerm]);

  // Reset page when search term changes
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Get paginated data
  const paginatedOrders = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredOrders.slice(startIndex, endIndex);
  }, [filteredOrders, page, rowsPerPage]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allChecked = {};
      paginatedOrders.forEach((order) => {
        allChecked[order.id] = true;
      });
      setCheckedItems((prev) => ({ ...prev, ...allChecked }));
    } else {
      const newCheckedItems = { ...checkedItems };
      paginatedOrders.forEach((order) => {
        delete newCheckedItems[order.id];
      });
      setCheckedItems(newCheckedItems);
    }
  };

  const allSelectedOnPage = paginatedOrders.length > 0 && paginatedOrders.every((order) => checkedItems[order.id]);

  // Update selectedOrderIds when checkedItems changes
  useEffect(() => {
    const selectedIds = Object.keys(checkedItems);
    setSelectedOrderIds(selectedIds);
  }, [checkedItems]);

  // Handle button click to submit selected orders and picker to another API
  const handleSelectionSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (!customerInputValue || !customerInputValue.value || customerInputValue.value === "undefined") {
      toast.error('Please select Picker first.');
      pickerRef.current.focus();
      return;
    }

    if (selectedOrderIds.length === 0) {
      toast.error('Please select at least one order.');
      return;
    }

    const accessToken = localStorage.getItem('accessToken');
    const token = localStorage.getItem("token");

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    try {
      const data = await postCreatePicking({
        picker: String(customerInputValue.value),
        val: selectedOrderIds.map(String),
      }, token);

      if (data.status === 'true') {
        // Reset selected picker and checkboxes after successful picking creation
        setCustomerInputValue('');
        setSelectedPicker('');
        setCheckedItems({});
        setSelectedOrderIds([]);
        const picklistUrl = data.picklist_number;
        const picklistNo = picklistUrl.substring(picklistUrl.lastIndexOf('/') + 1);
        if (isSingleOrderPicking) {
          const next = singlePickingSuccessCount + 1;
          setSinglePickingSuccessCount(next);
          toast.success(`Create Picking successfully`);
          await fetchData();
        } else {
          toast.success('Create Picking successfully.');
          setTimeout(() => {
            window.location.href = config.BASE_URL + `/sales/view_picking_list/${picklistNo}`;
          }, 1500);
        }
      } else {
        toast.error('Please select order first.');
      }

    } catch {
    }
  };
  return (
    <>
      <Box sx={{ width: "100%", backgroundColor: inTabs ? "transparent" : "#f5f7fa", height: inTabs ? "auto" : "calc(100vh - 110px)" }}>
        <Paper
        >
          {/* Filter Section */}
          <Box sx={{ p: 1 }}>
            <Grid2
              container
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <Box>
                  <Typography className="page-title">
                    Create Picking
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <TextField
                  className="input-border"
                  fullWidth
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  size="small"
                  placeholder="Search orders..."
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Iconify
                            icon="eva:search-outline"
           
                          />
                        </InputAdornment>
                      ),
                    },
                  }}
              
                />
              </Grid2>

              {/* Picker */}
              <Grid2
                size={{ xs: 12, sm: 3 }}
                display="flex"
                justifyContent="flex-end"
                flexDirection={{ xs: 'column', md: 'row' }}

              >
                <Autocomplete
                  fullWidth
                  options={customerOptions}
                  value={customerInputValue}
                  onChange={handleChange}
                  onInputChange={handlePickerChange}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  renderInput={(params) => (
                    <TextField
                      className="input-border"
                      {...params}
                      placeholder="Select Picker"
                      size="small"
                      fullWidth
                      inputRef={pickerRef}
       
                    />
                  )}
                />
              </Grid2>

              {/* Submit */}
              <Grid2
                size={{ xs: 12, sm: 1 }}
                display="flex"
                justifyContent={{ xs: "stretch", sm: "flex-end" }}
              >
                <form onSubmit={handleSelectionSubmit} style={{ width: "100%" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    className="button-variant-contained"
                    fullWidth
                  >
                    Submit
                  </Button>
                </form>
              </Grid2>
            </Grid2>
          </Box>

          {/* Table Section */}
          <TableContainer>
            <Table
              size="medium"
              className="table-cell-border"
              sx={{
                "& .MuiTableCell-paddingCheckbox": {
                  width: 52,
                  minWidth: 52,
                  px: { xs: 0.5, sm: 0.4 },
                  py: { xs: 0.5, sm: 0.4 },
                }
              }}
            >
              <colgroup>
                <col style={{ width: 52 }} />
                {columns.filter(col => col.id !== "checkbox").map((column) => (
                  <col key={column.id} style={{ width: column.width ? `${column.width}px` : "auto" }} />
                ))}
              </colgroup>
              <TableHead>
                <TableRow className="table-cell-header">
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={paginatedOrders.some((order) => checkedItems[order.id]) && !allSelectedOnPage}
                      checked={allSelectedOnPage && paginatedOrders.length > 0}
                      onChange={handleSelectAll}
                      size="small"
                      className="checkBox"
                    />
                  </TableCell>
                  {columns.filter(col => col.id !== "checkbox").map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.numeric ? "right" : "left"}
                      sx={{
                        width: { xs: "auto", sm: column.width ? `${column.width}px` : "auto" },
                        minWidth: { xs: column.width ? `${Math.min(column.width, 100)}px` : "auto", sm: column.width ? `${column.width}px` : "auto" },
                        whiteSpace: column.id === "customer" ? "nowrap" : undefined
                      }}

                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  Array.from({ length: 10 }).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell padding="checkbox">
                        <Skeleton variant="rectangular" width={36} height={20} />
                      </TableCell>
                      {columns.filter(col => col.id !== "checkbox").map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.numeric ? "right" : "left"}
                          sx={{
                            py: { xs: 1, sm: 1.5 },
                            px: { xs: 1, sm: 2 },
                            fontSize: { xs: "0.7rem", sm: "0.75rem" },
                            width: { xs: "auto", sm: column.width ? `${column.width}px` : "auto" },
                            whiteSpace: column.id === "customer" ? "nowrap" : undefined
                          }}
                        >
                          <Skeleton variant="text" width="60%" />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : paginatedOrders.length > 0 ? (
                  paginatedOrders.map((row) => (
                    <TableRow
                      key={row.id}
                      hover
                      className="table-style"
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={!!checkedItems[row.id]}
                          onChange={() => handleCheckboxChange(row.id)}
                          size="small"
                          className="checkBox"
                        />
                      </TableCell>
                      {columns.filter(col => col.id !== "checkbox").map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.numeric ? "right" : "left"}
                          sx={{
                            py: { xs: 1, sm: 1.5 },
                            px: { xs: 1, sm: 2 },
                            fontSize: { xs: "0.7rem", sm: "0.75rem" },
                            color: "#212b36",
                            width: { xs: "auto", sm: column.width ? `${column.width}px` : "auto" },
                            minWidth: { xs: column.width ? `${Math.min(column.width, 100)}px` : "auto", sm: column.width ? `${column.width}px` : "auto" },
                            whiteSpace: column.id === "customer" ? "nowrap" : undefined,
                            ...(column.numeric && { fontWeight: 500 })
                          }}
                        >
                          {column.id === "reference_no" ? (
                            <MuiLink
                              href={`${BASE_URL}/picking/picking_list/view/${row.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{
                                color: "inherit",
                                textDecoration: "underline !important",
                                textDecorationColor: "currentColor",
                                textUnderlineOffset: "2px",
                                "&:hover": {
                                  textDecoration: "underline !important",
                                  textDecorationColor: "currentColor"
                                }
                              }}
                            >
                              {row.reference_no}
                            </MuiLink>
                          ) : column.id === "total" ? (
                            `${row.total_item ?? 0}/${row.total_qty ?? 0}`
                          ) : (
                            row[column.id] ?? ""
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} sx={{ py: 8 }}>
                      <Typography align="center" sx={{ color: "#637381", fontSize: "0.75rem" }}>
                        No orders found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination Section */}
          <Box display="flex" justifyContent="flex-end" alignItems="center"
          >
            <TablePagination
              component="div"
              count={filteredOrders.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
              className="pagination-styles"
            />
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default PickingCreate;